/**
 * contractId -> contract symbol (e.g. 3570918 -> "MNQZ6"), learned from any
 * position or order that carries both. Tradovate position frames often arrive
 * with only a contractId; the name shows up later (the service resolves it on
 * its side), so anything keyed by symbol - like restrain - looks it up here.
 *
 * Kept in its own module so restrainStore and brokerStore can both use it
 * without importing each other.
 */

const cache = new Map<string, string>();

/**
 * A symbol that names no contract: empty, a bare contract id ("3570918"), or a
 * service placeholder ("Contract_3570918", "Contract#3570918", "UNKNOWN").
 */
export const isPlaceholderSymbol = (s: string | null | undefined): boolean => {
  const v = (s ?? '').trim();
  return v === '' || /^\d+$/.test(v) || /^contract[_#]/i.test(v) || /^unknown$/i.test(v);
};

/** Remember a contractId's symbol (placeholders are ignored). */
export function rememberContractSymbol(contractId: number | string | null | undefined, symbol: string | null | undefined): void {
  if (contractId == null || contractId === '' || isPlaceholderSymbol(symbol)) return;
  cache.set(String(contractId), String(symbol).trim());
}

/** The known symbol for a contractId, or undefined. */
export function contractSymbolFor(contractId: number | string | null | undefined): string | undefined {
  if (contractId == null || contractId === '') return undefined;
  return cache.get(String(contractId));
}

/** Test hook. */
export const _resetContractSymbols = (): void => cache.clear();
